import { useState } from 'react'

import {
  ChartArea,
  ChartBar,
  ChartDonut,
  ChartPie,
  ChartSparkline,
} from '../../Chart'
import { InhabitantsStatisticModal } from '../../Inhabitants'
import { Container } from '../Container'

import {
  CHART_AREA_EXAMPLE_MOCK,
  CHART_AREA_EXAMPLE_SERIES,
  CHART_EXAMPLE_MOCK,
  CHART_SPARKLINE_EXAMPLE_MOCK,
} from './Charts.mock'

function Charts() {
  const [modal, setModal] = useState(false)

  const modalProps = {
    onClose: () => setModal(null),
  }

  return (
    <>
      <Container label='Chart pie example'>
        <div style={{ height: 320, width: '100%' }}>
          <ChartPie data={CHART_EXAMPLE_MOCK} />
        </div>
      </Container>
      <Container label='Chart donut example'>
        <div style={{ height: 240, width: '100%' }}>
          <ChartDonut items={CHART_EXAMPLE_MOCK} />
        </div>
      </Container>
      <Container label='Chart area example'>
        <div style={{ height: 240, width: '100%' }}>
          <ChartArea
            data={CHART_AREA_EXAMPLE_MOCK}
            series={CHART_AREA_EXAMPLE_SERIES}
          />
        </div>
      </Container>
      <Container label='Chart sparkline example'>
        <div style={{ height: 52, width: 124 }}>
          <ChartSparkline
            color='var(--color-success)'
            data={CHART_SPARKLINE_EXAMPLE_MOCK}
          />
        </div>
      </Container>
      <Container label='Chart bar example'>
        <div style={{ height: 240, width: '100%' }}>
          <ChartBar data={CHART_EXAMPLE_MOCK} />
        </div>
      </Container>
      <Container>
        <div
          onClick={() =>
            setModal(<InhabitantsStatisticModal {...modalProps} />)
          }
        >
          Click for open statistic modal
        </div>
      </Container>
      {modal}
    </>
  )
}

export default Charts
